import React from 'react';
import { Images } from 'utils';
import { highwayConStatus, highwayConStatusEnum as GoHighwayStatusesStepsStatus } from './constants';

export const GoHighwayStatusesSteps = ({ steps, status }) => {
  const currentIndex = steps.findIndex(step => step.id === status);

  return (
    <div className="goHighway-statuses-steps-wrapper">
      <h3 className="goHighway-statuses-steps-title">
        GoHighway
      </h3>
      {status === GoHighwayStatusesStepsStatus.DISMISSED ? (
          <div className='goHighway-statuses-dismissed'>
            <div className='goHighway-statuses-dismissed-img'>
              <img src={Images.warning} alt="warning" />
            </div>

            <p className='goHighway-statuses-dismissed-text'>
              {highwayConStatus.DISMISSED}.
            </p>
          </div>
        )
        :
        status === GoHighwayStatusesStepsStatus.ONBOARDED ?(
            <div className='goHighway-statuses-dismissed' style={{
              background:'rgba(200, 130, 30, 0.10)'
            }}>
              <div className='goHighway-statuses-onboarded-img'>
                <img src={Images.CheckboxBase2} alt="warning" />
              </div>

              <p className='goHighway-statuses-dismissed-text'>
                {highwayConStatus.ONBOARDED}.
              </p>
            </div>
          )
          :
        <div className="goHighway-statuses-steps-block">
          {steps.map((step, index) => {
            const isCompleted = index <= currentIndex;
            return (
              <div className="goHighway-statuses-step-item-and-label" key={index}>
                <div className="goHighway-statuses-step-item-wrapper">
                  <div
                    className="goHighway-statuses-step-item-line"
                    style={{
                      backgroundColor: index === 0 ? 'transparent' : isCompleted ? '#FDC517' : '',
                    }}
                  />

                  <div className="goHighway-statuses-step-item-is-checked">
                    {isCompleted ?
                      <img src={Images.CheckboxBase2} alt="checked" />
                      :
                      <div className="goHighway-statuses-step-item-circle" />
                    }
                  </div>

                  <div
                    className="goHighway-statuses-step-item-line"
                    style={{
                      backgroundColor: (index === steps?.length - 1) ? 'transparent' : isCompleted ? '#FDC517' : '',
                    }}
                  />
                </div>

                <h5 className="goHighway-statuses-step-item-name">
                  {step.name}
                </h5>
              </div>
            );
          })}
        </div>

      }
    </div>
  );
};

